import styled, { keyframes } from "styled-components";

const pic1 = keyframes`
    25% {transform: translateX(30px) scale(0.6);}
    50% {
        transform: translateX(60px) scale(1);
    }
    75% {
        transform: translateX(30px) scale(1.4);
        z-index: 2;
    }
    99% {
        transform: translateX(0) scale(1);
    }
    100% {
        z-index: 1;
    }
`;

const pic2 = keyframes`
    25% {transform: translateX(-30px) scale(1.4);}
    50% {
        transform: translateX(-60px) scale(1);
    }
    75% {
        transform: translateX(-30px) scale(0.6);
        z-index: 1;
    }
    99% {
        transform: translateX(0) scale(1);
    }
    100% {
        z-index: 2;
    }
`

const loaderScaleOut = keyframes`
    to { transform: scale(0);}
`;

export const StyledLoader = styled.div`
    position: absolute;
    height: 135px;
    width: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.loaderScaleOut {
        animation: ${loaderScaleOut} 0.5s linear forwards;
    }

    img{
        height: 55px;

        &:nth-child(1){
            animation: ${pic1} 1.5s linear infinite;
            z-index: 1;
        }
        &:nth-child(2){
            animation: ${pic2} 1.5s linear infinite;
            z-index: 2;
        }
    }
` as any;
